import { vnModule_knockoutJS } from '../../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler_requestType } from '../../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { header } from '../header';
import { adminQuestionBanks_template } from '../../components/templates/recruiting/adminQuestionBanks_template';
import { startListLoading, stopListLoading } from '~/utils/listLoading';
export class admin_question_banks extends vnModule_knockoutJS {
    /**
     * Return the module key used by the Valnet app framework.
     *
     * @return string
     */
    getModuleName() {
        return 'admin_question_banks';
    }
    /**
     * Build and return the DOM content for this module.
     *
     * @return Array<Element>
     */
    buildContent() {
        const zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        const loadedModule = zoneHeader.loadedModule;
        loadedModule.setHeaderTitle('Question Banks');
        this.adminQuestionBanks_template = new adminQuestionBanks_template('adminQuestionBanksTemplate', this.viewModel, this);
        this.template = this.adminQuestionBanks_template;
        return [this.adminQuestionBanks_template.build()];
    }
    /**
     * Load the initial data required by the page.
     *
     * @return void
     */
    fillPage() {
        this.updateViewModelFromPath();
        this.getListData();
    }
    /**
     * Return list data.
     *
     * @return void
     */
    getListData() {
        startListLoading(this, this.adminQuestionBanks_template.builtTemplate);
        const subViewModel = this.adminQuestionBanks_template.getViewModelForRequest();
        this.sendFilterCall('/api/admin/rest/api/lead/recruiting/banks', subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getQuestionBanks');
    }
    /**
     * Handle the API response for data request.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onDataRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response || '{}');
                const rows = (responseParsed.data && responseParsed.data.paginatedData) || responseParsed.data || [];
                const vmReq = obj.adminQuestionBanks_template.getViewModelForRequest();
                const totalCount = Number(responseParsed.totalCount || 0);
                const perPage = vmReq.pagination && vmReq.pagination.itemPerPage ? Number(vmReq.pagination.itemPerPage) : 20;
                const totalPages = Math.max(1, Number(responseParsed.totalPage || Math.ceil(totalCount / Math.max(1, perPage))));
                const paginationVm = obj.adminQuestionBanks_template.getPaginationViewModel();
                if (paginationVm && typeof paginationVm.pageNumber === 'function') {
                    paginationVm.pageNumber(Math.max(1, Number(responseParsed.currentPage || paginationVm.pageNumber())));
                }
                obj.validationTemplate.clearMessages();
                obj.updateList(rows);
                obj.updatePagination(totalCount);
                obj.setResultInfo(totalCount, totalPages, req);
            });
            if (req.request.readyState === 4 && req.request.status !== 0) {
                stopListLoading(obj, obj.adminQuestionBanks_template.builtTemplate);
            }
        };
    }
    /**
     * Update list.
     *
     * @param responseParsedData any
     * @return void
     */
    updateList(responseParsedData) {
        this.adminQuestionBanks_template.setQuestionBanks(responseParsedData || []);
    }
    /**
     * Update the pagination partial with the result count.
     *
     * @param totalCount any
     * @return void
     */
    updatePagination(totalCount) {
        this.adminQuestionBanks_template.updatePagination(totalCount);
    }
    /**
     * Update the result-info partial with list metadata.
     *
     * @param totalCount any
     * @param totalPage any
     * @param req any
     * @return void
     */
    setResultInfo(totalCount, totalPage, req) {
        const execTime = Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100;
        this.adminQuestionBanks_template.setResultInfo(totalCount, totalPage, execTime);
    }
    /**
     * Handle pagination click events.
     *
     * @param paginationId string
     * @return void
     */
    paginationOnPageClick() {
        this.getListData();
    }
    /**
     * Handle list reorder.
     *
     * @return void
     */
    listReorder() {
        this.getListData();
    }
    /**
     * Navigate to edit question bank.
     *
     * @param id number
     * @return void
     */
    editQuestionBank(id) {
        page('/admin/questionBank/' + id);
    }
    /**
     * Navigate to create question bank.
     *
     * @return void
     */
    createQuestionBank() {
        page('/admin/questionBank/new');
    }
    /**
     * Navigate to the available questions page.
     *
     * @return void
     */
    openAvailableQuestions() {
        page('/admin/recruitingQuestions');
    }
}
